import type { ChatRoom, ChatUser } from 'models';
import { usePermissions } from 'permissions';
import { Button, Flex, GroupLineIcon, Title } from 'ui';

import { ChatGroupInfoMemberItem } from './chat-group-info-member-item';

type P = {
  chatroom: ChatRoom;
  members: ChatUser[];
  onAddMember: () => void;
  onRemoveMember: (member: ChatUser) => void;
};

const ChatGroupInfoMembers = ({ chatroom, members, onAddMember, onRemoveMember }: P) => {
  const { canAddChatMember, canRemoveChatMember } = usePermissions();

  return (
    <Flex gap="ms" vertical>
      <Flex align="center" justify="space-between">
        <Flex align="center" gap="xxs">
          <Title icon={<GroupLineIcon size="extra-small" />} level={4}>
            Members
          </Title>
        </Flex>
        {canAddChatMember({ chatroom }) ? (
          <Button onClick={onAddMember} type="link-primary">
            Add members
          </Button>
        ) : null}
      </Flex>
      <Flex gap="ms" vertical>
        {members.map((member) => (
          <ChatGroupInfoMemberItem
            canRemove={canRemoveChatMember({ chatroom, memberUserId: member.id })}
            key={member.id}
            member={member}
            onRemove={onRemoveMember}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default ChatGroupInfoMembers;
